import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/_public/terms-of-service")({
  component: () => <Navigate to="/terms" replace />,
});
